/* weezy-mailer-cart — flip the mailer once whenever the cart changes.
   Loaded with `defer`, so it never touches the critical path.
   Gopal 2026-08-11.

   EVENT SOURCES — this theme is NOT stock Dawn, so we feature-detect all three:
     1. 'weezy:cart:changed'  — the custom drawer controller (authoritative here;
                                dispatched by sections/weezy-cart-drawer.liquid)
     2. 'cart-update'         — Dawn's PUB_SUB constant, still used by the legacy
                                assets/cart.js + product-form.js path
     3. 'cart:updated'        — older themes / third-party apps
   Listening to all three is harmless: repeat triggers are ignored while a flip
   is already running.

   will-change is added only for the duration of the animation and removed on
   animationend, so no element keeps a compositor layer at rest. */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function flip(el) {
    if (REDUCED || !el || el.classList.contains('is-flipping')) return;
    var inner = el.querySelector('.wz-mailer__inner');
    if (inner) inner.style.willChange = 'transform';
    el.classList.add('is-flipping');
    var done = function () {
      el.classList.remove('is-flipping');
      if (inner) inner.style.willChange = ''; /* never leave it promoted */
      el.removeEventListener('animationend', done);
    };
    el.addEventListener('animationend', done);
    /* belt-and-braces: if animationend never fires (element hidden mid-flip),
       clear the state so the next cart update can still animate */
    setTimeout(done, 1200);
  }

  function flipAll() {
    document.querySelectorAll('[data-wz-mailer][data-mode="event"]').forEach(flip);
  }

  ['weezy:cart:changed', 'cart-update', 'cart:updated'].forEach(function (evt) {
    document.addEventListener(evt, flipAll);
  });

  /* Dawn's pub/sub is not a DOM event — subscribe if the helper exists. */
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, flipAll);
    }
  } catch (e) {}
})();
